import PartySocket from "partysocket";
import {generateUUID} from "./helpers/uuid";

export const partyId = generateUUID()
sessionStorage.setItem('gigachat:partyID', partyId);

export const gigaParty = new PartySocket({
    host: "ws://127.0.0.1:1999",
    room: partyId,
});